import options from './chart-desk-occupancy.component';

export default {
    selector: 'dtChartDeskOccupancy',
    options
};
